import { Languages } from 'lucide-react';
import { useLanguage } from '../../lib/i18n/LanguageContext';
import { useTranslation } from 'react-i18next';

const LanguageSwitch = () => {
  const { language, setLanguage } = useLanguage();
  const { t } = useTranslation();

  return (
    <div className="relative group">
      <button
        className="flex items-center space-x-1 text-gray-700 hover:text-blue-600 transition-colors"
        aria-label={t('language_switch')}
      >
        <Languages className="h-5 w-5" />
        <span className="uppercase">{language}</span>
      </button>
      
      <div className="absolute right-0 mt-2 py-2 w-32 bg-white rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all">
        <button
          onClick={() => setLanguage('en')}
          className={`block w-full px-4 py-2 text-left hover:bg-gray-100 ${
            language === 'en' ? 'text-blue-600' : 'text-gray-700'
          }`}
        >
          English
        </button>
        <button
          onClick={() => setLanguage('de')}
          className={`block w-full px-4 py-2 text-left hover:bg-gray-100 ${
            language === 'de' ? 'text-blue-600' : 'text-gray-700'
          }`}
        >
          Deutsch
        </button>
      </div>
    </div>
  );
};

export default LanguageSwitch;